<template>
    <div class="white-list-add-dialog-box"> 
        <el-dialog
            title="设置非白名单核销次数"
            :visible.sync="dialogVisible"
            width="480px"
            custom-class="white-list-add-dialog-class" 
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :destroy-on-close="true"
            :before-close="close"
            @close="close"
        > 
        <div class="white-list-content">
            <el-form size="small" ref="form" :model="formData" :rules="rules" label-width="100px">
                <el-form-item label="核销次数" prop="verify_limit">
                    <el-input-number class="white-list-input-number" v-model="formData.verify_limit" controls-position="right" :min="0" ></el-input-number>

                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="suer" :disabled="loading">确定</el-button>
           
        </div>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        props:{
            dialogVisible:{
                type: Boolean,
                default:false
            },
            whiteListData:{
                type: Object,
                default: () => {}
            },
            loading:{
                type: Boolean,
                default:false
            }
        },
        data() { 
            return{ 
                formData:{
                    verify_limit:'',
                },
                rules:{
                    verify_limit:[
                        { required: true, message: '核销次数', trigger: 'blur' }
                    ],
                }
            }
        },
        mounted() { 
            this.formData = {...this.formData,...this.whiteListData}
            // this.formData.ip_address= this.whiteListData.ip
            console.log(this.formData)
        },
        methods:{
            close(){
                this.$refs.form.resetFields()
                this.$emit('close')
            },
            suer(){
                this.$refs.form.validate(async valid => {
                    if (valid) {
                        console.log('===',this.formData)
                        this.$emit('sure',this.formData)
                    } else {
                        return false;
                    }
                })
            }
        },
    }
</script>
<style scoped lang="scss">
    .white-list-add-dialog-class{
        .form-tips {
            color: #909399;
            font-size: 12px;
            margin-top: 8px;
        }
        .white-list-input-number{
            width: 150px;
        }
    }

</style>